export const SET_INTERCOM_LOADING_ERROR = 'SET_INTERCOM_LOADING_ERROR';
export const SET_INTERCOM_THREADS = 'SET_INTERCOM_THREADS';
export const SET_READ_INTERCOM_THREAD = 'SET_READ_INTERCOM_THREAD';
export const UPDATE_INTERCOM_THREAD = 'UPDATE_INTERCOM_THREAD';
export const SET_DELETED_INTERCOM_THREADS = 'SET_DELETED_INTERCOM_THREADS';
export const SET_INTERCOM_PLUGINS = 'SET_INTERCOM_PLUGINS';
